module.exports = "/_next/static/images/0bf539ab7da5d277955b072a40078d21-credit-card-autonomy@3x.png";